import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import useColor from '@/hooks/domain/useColor';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';

const NotFoundPage = () => {
  const color = useColor();
  const { navigate } = useWorkspaceRouter();
  return (
    <Style a="center" j="center" d="column">
      <img src="/assets/logo-syncly.svg" width={54} height={54} alt="syncly" />
      <Space h="32px" />
      <Heading type="hero">404</Heading>
      <Space h="16px" />
      <Heading type="h2" color={color.gray700}>
        This page could not be found.
      </Heading>
      <Space h="24px" />
      <Button
        onClick={() => {
          navigate('/');
        }}
        variant={'outlined'}
      >
        Go back to the workspace
      </Button>
    </Style>
  );
};

const Style = styled(Flex)`
  width: 100%;
  height: 100vh;
`;

export default NotFoundPage;
